import tw, { styled } from 'twin.macro';

export const CheckboxFieldsWrapper = styled.div`
  ${tw`mt-2 px-2 py-1 pb-0`}
  border-radius: 3px;
  background-color: transparent;
  width: 100%;
  font-size: var(--formFontSize);
  border-radius: var(--formFieldBorderRadius);
  border-color: var(--formFieldBorderColor);

  &.inline {
    display: flex;
    flex-flow: row wrap;
    justify-content: flex-start;

    > div {
      min-width: 200px;
    }
  }
`;

export const CheckboxField = styled.div``;

export const Checkbox = styled.div`
  ${tw`relative py-0.5 my-4`}
`;

export const CheckboxInput = styled.input`
  ${tw`cursor-pointer opacity-50 absolute top-0 w-4.5 h-4.5`};
  accent-color: #1a8caf;

  &:checked {
    ${tw`opacity-100`};
  }
`;

export const CheckboxInputLabel = styled.label`
  ${tw`ml-2 mr-2 block pl-7 outline-none text-base opacity-70`}
  font-family: 'Circular Std' !important;
  color: #777;
  user-select: none;
  line-height: 15px;

  ${({ notInBuilder }) =>
    notInBuilder &&
    `
    font-size: var(--formFontSize);
    color: var(--formBodyLabelColor, var(--formTextColor));
    text-transform: var(--formLabelTransform);
    font-family: var(--formFontType) !important;
  `}

  &.rtl {
    ${tw`pr-7 pl-0`};
  }
`;
